
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        carrierName: {
            type: String,
            default: null
        },
        carBrand: {
            type: String,
            default: null
        },
        carNumber: {
            type: String,
            default: null
        },
        driverName: {
            type: String,
            default: null
        },
        driverPhone: {
            type: String,
            default: null
        },
        driverIdNumber: {
            type: String,
            default: null
        },
        driverLicenseNumber: {
            type: String,
            default: null
        },
        trailerLicenseNumber: {
            type: String,
            default: null
        }
    }
})
